import { render, staticRenderFns } from "./CtrlSwitchValues.vue?vue&type=template&id=10c2eaf2"
import script from "./CtrlSwitchValues.vue?vue&type=script&lang=js"
export * from "./CtrlSwitchValues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports